var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChampionsBgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 773.5,
    height: 773
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 386.5h773"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 386.5,
    cy: 386.5,
    r: 386.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.5,
    cy: 386.5,
    r: 385.5
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NzMuNSIgaGVpZ2h0PSI3NzMiIHZpZXdCb3g9IjAgMCA3NzMuNSA3NzMiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02MTggLTEzMjIpIj48bGluZSB4Mj0iNzczIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MTguNSAxNzA4LjUpIiBmaWxsPSJub25lIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMiIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYxOCAxMzIyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2Utd2lkdGg9IjIiPjxjaXJjbGUgY3g9IjM4Ni41IiBjeT0iMzg2LjUiIHI9IjM4Ni41IiBzdHJva2U9Im5vbmUiLz48Y2lyY2xlIGN4PSIzODYuNSIgY3k9IjM4Ni41IiByPSIzODUuNSIgZmlsbD0ibm9uZSIvPjwvZz48L2c+PC9zdmc+";
export { SvgChampionsBgMobile as ReactComponent };